import { render, staticRenderFns } from "./SysDialog.vue?vue&type=template&id=25b8fdbe&scoped=true"
import script from "./SysDialog.vue?vue&type=script&lang=js"
export * from "./SysDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b8fdbe",
  null
  
)

export default component.exports